<template>
  <div class="resumen-vacaciones">
    <b-row class="indicadores" v-if="items.length > 0">
      <b-col>
        <b-card class="text-center">
          <b-card-title class="text-primary titulo">
            FECHA DE INGRESO</b-card-title
          >
          <span class="valor"> {{ fechaIngreso | myGlobal }}</span>
        </b-card>
      </b-col>

      <!-- <b-col>
        <b-card class="text-center">
          <b-card-title class="text-primary titulo"> FECHA ACTUAL</b-card-title>
          <span class="valor">{{ fechaActual | myGlobal }}</span>
        </b-card>
      </b-col> -->

      <b-col>
        <b-card class="text-center">
          <b-card-title class="text-primary titulo">
            DIAS LABORADOS</b-card-title
          >
          <span class="valor"> {{ totalDiasLaborados }}</span>
        </b-card>
      </b-col>

      <b-col>
        <b-card class="text-center">
          <b-card-title class="text-primary titulo">
            VACACIONES POR REGIMEN
          </b-card-title>
          <span class="valor"> {{ vacacionesPorRegimen }}</span>
        </b-card>
      </b-col>

      <b-col>
        <b-card class="text-center">
          <b-card-title class="text-primary titulo">
            VACACIONES TOMADAS
          </b-card-title>
          <span class="valor"> {{ vacacionesTomadas }}</span>
        </b-card>
      </b-col>

      <b-col>
        <b-card class="text-center">
          <b-card-title class="text-primary titulo">
            VACACIONES DISPONIBLES
          </b-card-title>
          <span class="valor"> {{ vacacionesDisponibles }}</span>
        </b-card>
      </b-col>
    </b-row>

    <b-row class="periodos" v-if="items.length > 0">
      <b-col
        cols="12"
        sm="6"
        md="4"
        lg="3"
        v-for="(item, index) in items"
        :key="index"
        class="mb-2"
      >
        <b-card class="text-center">
          <b-card-title class="text-primary">
            <span class="titulo"> PERIODO {{ item.periodo }} </span>
          </b-card-title>

          <b-card-sub-title class="text-secondary">
            Dias acumulados: {{ item.vacaciones_acumuladas }}
          </b-card-sub-title>

          <b-row class="px-0 mt-1">
            <b-col class="p-0">
              <div class="subtitulo text-success">USADO</div>
            </b-col>
            <b-col class="p-0">
              <div class="subtitulo text-danger">ACUMULADO</div>
            </b-col>
            <b-col class="p-0" v-if="index === items.length - 1">
              <div class="subtitulo text-warning">POR ACUMULAR</div>
            </b-col>
          </b-row>

          <b-row class="mb-1">
            <b-col class="p-0">
              <div class="valor bg-light-success">
                {{ item.vacaciones_tomadas }}
              </div>
            </b-col>
            <b-col class="p-0">
              <div class="valor bg-light-danger">
                {{ item.vacaciones_disponibles }}
              </div>
            </b-col>
            <b-col class="p-0" v-if="index === items.length - 1">
              <div class="valor bg-light-warning">
                {{ item.vacaciones_por_acumular }}
              </div>
            </b-col>
          </b-row>

          <b-row class="fechas">
            <b-col class="p-0">
              <div
                v-for="vacacion in item.detalle_vacaciones"
                :key="vacacion.id"
              >
                <div class="fecha bg-light-primary">
                  <div
                    class="d-flex align-items-center"
                    :class="{
                      'justify-content-between': vacacion.comprado,
                      'justify-content-center': !vacacion.comprado,
                    }"
                  >
                    <tabler-icon
                      v-if="vacacion.comprado == 1"
                      class="mr-1"
                      icon="MoneybagIcon"
                      :class="vacacion.pagado ? 'text-success' : 'text-danger'"
                      size="20"
                      v-b-tooltip.hover="
                        vacacion.fecha_pago
                          ? 'Pagado: ' + formatFechaPago(vacacion.fecha_pago)
                          : 'No pagado aún'
                      "
                    />

                    <span>{{ vacacion.fecha | myGlobal }}</span>
                  </div>
                </div>
              </div>
            </b-col>
            <b-col class="p-0"> </b-col>
            <b-col class="p-0" v-if="index === items.length - 1"> </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>

    <b-row v-else>
      <b-col>
        <span class="h2 text-center text-info">
          No se ha generado el resumen de vacaciones, revise nuevamente mañana.
        </span>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import VacacionesService from "@/views/rrhh/views/payroll/components/vacaciones/service/vacaciones.service.js";
export default {
  props: {
    id: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      items: [],
    };
  },
  computed: {
    totalDiasLaborados() {
      return this.items.reduce((total, item) => total + item.dias_laborados, 0);
    },
    vacacionesPorRegimen() {
      return this.items.length > 0
        ? this.items[this.items.length - 1].total_vacaciones_por_periodo
        : 0;
    },
    fechaIngreso() {
      return this.items.length > 0
        ? this.items[0].fecha_inicio
        : "No disponible";
    },
    fechaActual() {
      return new Date().toLocaleDateString();
    },
    vacacionesTomadas() {
      return this.items.length > 0
        ? this.items.reduce((total, item) => total + item.vacaciones_tomadas, 0)
        : 0;
    },
    vacacionesDisponibles() {
      return this.items.length > 0
        ? this.items.reduce(
            (total, item) => total + item.vacaciones_disponibles,
            0
          )
        : 0;
    },
  },
  methods: {
    formatFechaPago(fecha) {
      return fecha
        ? new Date(fecha).toLocaleString("es-PE", {
            dateStyle: "medium",
            timeStyle: "short",
          })
        : "";
    },
    async getResumenVacaciones(ctx) {
      try {
        this.addPreloader();
        const { data } = await VacacionesService.getVacacionesResumen({
          id: this.id,
        });
        this.items = data;
      } catch (error) {
        console.log(error);
      } finally {
        this.removePreloader();
      }
    },
  },
  mounted() {
    this.getResumenVacaciones();
  },
};
</script>

<style lang="scss" >
.resumen-vacaciones {
  .indicadores {
    .titulo {
      font-size: 1.2rem;
      font-weight: 900 !important;
    }
    .valor {
      font-size: 1.2rem;
      font-weight: 900 !important;
    }
  }

  .periodos {
    .titulo {
      font-size: 1.2rem;
      font-weight: 900;
    }

    .subtitulo {
      font-size: 1rem;
      font-weight: 600;
    }

    .valor {
      display: inline-block;
      min-width: 30px; /* Tamaño mínimo opcional */
      height: 30px;
      line-height: 30px;
      text-align: center;
      font-size: 1.2rem;
      font-weight: 900;
      border-radius: 50%;
      padding: 0;
    }

    .fechas {
      max-height: 40vh;
      overflow-y: auto;

      .fecha {
        display: inline-block;
        align-items: center;
        font-size: 1.2rem;
        font-weight: 900;
        padding: 0.5rem;
        margin-bottom: 0.5rem;
        border-radius: 0.5rem;
      }
    }
  }
}
</style>